<div class="modal-header">
  <app-summary-top
    class="w-100"
    [header]="header"
    [name]="baseService?.name"
    [model$]="form?.observableModel"
    [showSave]="showSave"
    [summaryItems]="summaryItems"
  ></app-summary-top>
</div>
<div class="modal-body p-3">
  @if (fields) {
    <app-base-edit-form
      [fields]="fields"
      [id]="id"
      [parentId]="parentId"
      [parentId2]="parentId2"
      [baseService]="baseService"
      [alwaysSave]="alwaysSave"
      (saved)="saved.emit($event)"
    ></app-base-edit-form>
  }
  <ng-content></ng-content>
</div>
